/* eslint-disable no-template-curly-in-string */
import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import { Box, Flex, ChakraProvider, Text, Avatar, Card, CardBody, VStack, } from '@chakra-ui/react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button,
  useDisclosure
} from '@chakra-ui/react'

import wisdomAvatar from "./assets/wisdom-avatar.svg";
//import send from "./assets/send.svg"
//import bot from './assets/bot.svg'
//import user from './assets/user.svg'
import styled from "@emotion/styled";

import Header from './Header';
import Footer from './Footer';
import Welcome from './Welcome';


import { Amplify, Auth, API, graphqlOperation, Predictions } from 'aws-amplify';


import { AmazonAIPredictionsProvider } from '@aws-amplify/predictions';

import { initText, questionPairs } from "./Init";

import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { PollyClient } from "@aws-sdk/client-polly";
import { getSynthesizeSpeechUrl } from "@aws-sdk/polly-request-presigner";
import VOICES from "./voices";

window.SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition;

const usrlang = navigator.language || navigator.userLanguage;


const getQuery = `query getQuery2($prompt: String!) {
  getQuery2(prompt: $prompt) {
    result
  }
}
`;


const AUTHConfig = {
  // To get the aws credentials, you need to configure
  // the Auth module with your Cognito Federated Identity Pool
  mandatorySignIn: false,
  userPoolId: process.env.REACT_APP_POOL_ID,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_APP_CLIENT_ID,
  region: process.env.REACT_APP_MAIN_REGION,
  identityPoolRegion: process.env.REACT_APP_AUTH_REGION,
};

const APIConfig = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_APPSYNC_OPENAI_ENDPOINT,
  aws_appsync_region: process.env.REACT_APP_MAIN_REGION,
  aws_appsync_authenticationType: process.env.REACT_APP_APPSYNC_AUTH_TYPE
};



Amplify.configure({
  // To get the AWS Credentials, you need to configure
  // the Auth module with your Cognito Federated Identity Pool
  Auth: AUTHConfig,
  Storage: {
    AWSS3: {
      bucket: 'prifina-data-749067669980-eu-west-1',
      region: 'eu-west-1'
    }
  },
  predictions: {
    convert: {
      translateText: {
        region: 'eu-west-1',
        proxy: false,
        defaults: {
          sourceLanguage: 'en',
          targetLanguage: 'fi'
        }
      },
      speechGenerator: {
        region: 'eu-west-1',
        proxy: false,
        defaults: {
          VoiceId: 'Joanna',
          LanguageCode: 'en-US',
        }
      },
      transcription: {
        region: 'eu-west-1',
        proxy: false,
        defaults: {
          language: 'en-US'
        }
      }
    },

  }
});

//Amplify.configure(awsconfig);
Amplify.addPluggable(new AmazonAIPredictionsProvider());
//Auth.configure(AUTHConfig);
API.configure(APIConfig);

const pollyClient = new PollyClient({
  region: "eu-west-1",
  credentials: fromCognitoIdentityPool({
    //client: new CognitoIdentityClient({ region: "eu-west-1" }),
    clientConfig: { region: "eu-west-1" },
    identityPoolId: "eu-west-1:9589f175-270e-418c-b724-23c136db8a7f" // IDENTITY_POOL_ID
  }),
});

const MainArea = styled(Box)`
width: 100%;
height: ${`calc(100vh - 210px)`};
/* border: 1px solid red; */
overflow-y:auto;
padding-top:32px;   
background-color: #F7FAFC;
`


const speakText = async (speak, lng) => {

  try {

    const voice = VOICES[lng] || null;

    if (voice) {
      const voiceParts = voice.split("/");
      const voiceEngine = voiceParts.length === 1 ? "neural" : "standard";
      const voiceID = voiceParts.length === 1 ? voiceParts[0] : voiceParts[1];
      console.log("VOICE ", voiceParts);
      // remove the A: in answer.... 
      if (speak.substring(1, 3) === ": ") {
        speak = speak.substring(3);
      }
      // Set the parameters
      const speechParams = {
        OutputFormat: "mp3", // For example, 'mp3'
        SampleRate: "24000", // For example, '16000
        Text: speak, // The 'speakText' function supplies this value
        TextType: "text", // For example, "text"
        VoiceId: voiceID, // For example, "Matthew"
        Engine: voiceEngine
      };
      let url = await getSynthesizeSpeechUrl({
        client: pollyClient, params: speechParams
      });
      console.log(url);

      let AudioContext = window.AudioContext || window.webkitAudioContext;
      console.log({ AudioContext });
      const audioCtx = new AudioContext();
      const source = audioCtx.createBufferSource();

      const audioBuffer = await fetch(url)
        .then(res => res.arrayBuffer())
        .then(ArrayBuffer => audioCtx.decodeAudioData(ArrayBuffer));
      source.buffer = audioBuffer;
      source.connect(audioCtx.destination);
      source.start(0);
    }
  } catch (err) {
    console.log("Error", err);
  }
};

function typeText(element, text) {
  let index = 0

  let interval = setInterval(() => {
    if (index < text.length) {
      element.innerHTML += text.charAt(index)
      index++
      const chatDiv = document.getElementById("chat_container");
      chatDiv.scrollTop = chatDiv.scrollHeight;

    } else {
      clearInterval(interval)
    }
  }, 20)
}

function generateUniqueId() {
  const timestamp = Date.now();
  const randomNumber = Math.random();
  const hexadecimalString = randomNumber.toString(16);

  return `id-${timestamp}-${hexadecimalString}`;
}


function chatStripeAI(value, uniqueId, key) {

  return <div key={"ai-" + key} className="wrapper ai">
    <div className="chat">
      <div className="profile">
        <img
          src={wisdomAvatar}
          alt="bot"
          style={{ transform: "scale(1.4)" }}
        />
      </div>
      <div className="message" id={uniqueId}><div className="dots"></div></div>
    </div>
  </div>

}


function chatStripeUser(value, uniqueId, key, name) {

  return <div key={"user-" + key} className="wrapper user">
    <div className="chat">
      <div className="profile">
        <Avatar name={name} width={"48px"} height={"48px"} />
      </div>
      <div className="message" id={uniqueId}>{value}</div>
    </div>
  </div>

}

async function translate(textToTranslate, targetLng, sourceLng = "en") {
  //sourceLanguage: 'en',
  //targetLanguage: 'fi'
  const lngExceptions = ["fr-CA", "pt-PT", "es-MX", "fa-AF", "zh-TW"];
  if (lngExceptions.indexOf(targetLng) === -1) {
    targetLng = targetLng.substring(0, 2);
  }
  console.log("TRANSLATE LNGS ", sourceLng, "=>", targetLng);
  return await Predictions.convert({
    translateText: {
      source: {
        text: textToTranslate,
        language: sourceLng,

        // language : "es" // defaults configured on aws-exports.js
        // supported languages https://docs.aws.amazon.com/translate/latest/dg/how-it-works.html#how-it-works-language-codes
      },
      targetLanguage: targetLng
      // targetLanguage: "en"
    }
  })
  //.then(result => console.log({ result }))
  //.catch(err => console.log({ err }));
}



const welcomeChat = (data, txts) => {
  const uniqueId = generateUniqueId();
  const name = data['name'];
  const location = data['location'];
  const eosLink = ` <a href=${process.env.REACT_APP_PRIFINA_WISDOM_EOS} target={"_blank"} rel="noreferrer"> ${txts[0]}</a>`;

  //txts[3] = txts[3].replace("[###2###]", eosLink).replace("[location]", " " + location);
  txts[3] = txts[3].replace("[###2###]", eosLink).replace("XXXZZZAAA", " " + location);
  //<a href={process.env.REACT_APP_PRIFINA_WISDOM_EOS} target={"_blank"} rel="noreferrer">EOS data repository</a>.


  return <div className="wrapper ai" key={"init-1"}>
    <div className="chat" key={"k-1"}>
      <div className="profile" key={"k-2"}>
        <img
          src={wisdomAvatar}
          alt="bot"
          style={{ transform: "scale(1.4)" }}
        />
      </div>

      <div className="message" id={uniqueId} key={"k-3"}>
        <div key={"k-4"}>{txts[1]}<b>{name}</b>,</div>
        <p key={"w-1"}><span dangerouslySetInnerHTML={{ __html: `${txts[2]}` }} /> </p>
        <p key={"w-2"}><span dangerouslySetInnerHTML={{ __html: `${txts[3]}` }} /></p>
      </div>

    </div>
  </div>
}

const examples = ({ texts, onClick }) => {
  return <>
    <Box key={"init-2"}>
      <Box pt={"50px"} textAlign="center">
        <Text as='b' fontSize='xl'>Examples</Text>
      </Box>
      <Box pt={"10px"} pb={"32px"}>
        <VStack spacing={"32px"} >
          {texts.map((txt, i) => {
            return <Card width={{ base: '360px', lg: '500px', xl: "640px" }} key={"card-" + i} style={{ cursor: "pointer" }} onClick={onClick}>
              <CardBody>
                <Text data-card={i}>{txt}</Text>
              </CardBody>
            </Card>
          })}

        </VStack>
      </Box>
    </Box>
  </>
}

function generateTextToSpeech(textToGenerateSpeech) {

  Predictions.convert({
    textToSpeech: {
      source: {
        text: textToGenerateSpeech,
      },
      voiceId: "Joanna" // default configured on aws-exports.js 
      // list of different options are here https://docs.aws.amazon.com/polly/latest/dg/voicelist.html
    }
  }).then(result => {
    let AudioContext = window.AudioContext || window.webkitAudioContext;
    console.log({ AudioContext });
    const audioCtx = new AudioContext();
    const source = audioCtx.createBufferSource();
    audioCtx.decodeAudioData(result.audioStream, (buffer) => {

      source.buffer = buffer;
      source.connect(audioCtx.destination);
      source.start(0);
    }, (err) => console.log({ err }));


  })
    .catch(err => console.log({ err }))


}

const useTranslations = (lng = "en-US", prompt) => {

  //console.log("SELECTED LNG ", lng);
  const defaultTexts = useRef({
    examples: ["What is the current rate of new business formation in our area, and how does it compare to previous years or other regions?",
      "Which industries or sectors are seeing the most growth in new business formation, and which are declining?",
      "What are the characteristics of successful innovation and entrepreneurship clusters in our area, and how can we replicate these factors in other parts of the region?"
    ],
    msgs: ["EOS data repository",
      "Hi ",
      "Welcome to <span translate=\"no\"> Wisdom</span> Demo. As your AI ecosystem advisor, I am here to assist you in making quicker and more informed decisions regarding your innovation entrepreneurship ecosystem with less effort. However, please note that the answers provided by this demo version are only realistic sounding based on artificial data.",
      `I am delighted to answer up to 10 questions about the innovation entrepreneurship ecosystem in XXXZZZAAA. I will provide you with realistic information based on the knowledge available in my <span translate="no"> [###2###]</span>. Please feel free to ask any questions you may have, or select a question from the examples provided.`
    ],
    app: {
      "welcome": "Welcome to <span translate=\"no\"> Wisdom</span> Demo!",
      "fillPrompt": "Please fill the following information to help us personalize your demo experience",
      "yourName": "Your Name",
      "emailAddress": "Email Address",
      "location": "Location (Region/Country/State/City)",
      "agree": "I have read and agree the",
      "terms": " Terms of Use",
      "start": "START A DEMO",
      "ask": "Ask me anything...",
      "book": "BOOK A CALL",
      "title": "Isn't it interesting?",
      "body1": "We hope you enjoyed trying out Wisdom and the magic it can do!",
      "body2": "It is time to take it further and unlock more features of <span translate=\"no\">Wisdom</span>, let’s arrange a call to discuss more details.",
      "about": "About <span translate=\"no\">Wisdom AI</span>",
      "queries": "queries used"
    },
    prompt: prompt
  })

  //<span translate="no">[location]</span>

  const exampleTexts = useRef(JSON.parse(JSON.stringify(defaultTexts.current.examples)));

  const msgs = useRef(JSON.parse(JSON.stringify(defaultTexts.current.msgs)));

  const appTxts = useRef(JSON.parse(JSON.stringify(defaultTexts.current.app)));

  const promptTxt = useRef(JSON.parse(JSON.stringify(defaultTexts.current.prompt)));

  const [translating, setTranslating] = useState(true);

  const [texts, setTexts] = useState({});

  const translationEffect = useRef(false);

  useEffect(() => {
    console.log("Translation ", translating, lng)
    async function init() {
      console.log("TRANSLATING");
      translationEffect.current = true;
      //{text: 'xxxxalueisiin?', language: 'fi'}
      const isEnglish = (lng.startsWith("en-") || lng === "en");

      if (!isEnglish) {
        const promptTxts = promptTxt.current.map(txt => {
          return translate(txt, lng);
        })
        await Promise.all(promptTxts).then((res) => {
          console.log("PROMPT ", res)
          res[0].text = res[0].text.replace("****", " Wisdom AI");
          promptTxt.current = res.map(t => t.text);
        })

        const examples = exampleTexts.current.map(txt => {
          return translate(txt, lng);
        })
        await Promise.all(examples).then((res) => {
          exampleTexts.current = res.map(t => t.text);
        })
        // const text0 = await translate(exampleTexts[0], lng);
        // exampleTexts[0] = text0.text;

        const welcomeTxts = msgs.current.map(txt => {
          return translate(txt, lng);
        })
        await Promise.all(welcomeTxts).then((res) => {
          const linkEOS = '<a href={process.env.REACT_APP_PRIFINA_WISDOM_EOS} target={"_blank"} rel="noreferrer">[###3###]</a>';

          //let linkText = "EOS data repository";
          msgs.current[1] = res[1].text;
          msgs.current[2] = res[2].text.replace("[###1###]", " Wisdom");
          msgs.current[3] = res[3].text.replace("[###2###]", linkEOS.replace("[###3###]", res[0].text));
          //msgs.current = res.map(t => t.text);
        })

        const txts = Object.keys(appTxts.current).map(key => {
          return translate(appTxts.current[key], lng);
        });
        await Promise.all(txts).then((res) => {
          //console.log("APP ", res);
          //appTxts.current = res.map(t => t.text);
          Object.keys(appTxts.current).forEach((key, i) => {
            appTxts.current[key] = res[i].text;
          });
        })
      } else {

        exampleTexts.current = JSON.parse(JSON.stringify(defaultTexts.current.examples));
        msgs.current = JSON.parse(JSON.stringify(defaultTexts.current.msgs));
        appTxts.current = JSON.parse(JSON.stringify(defaultTexts.current.app));
        promptTxt.current = JSON.parse(JSON.stringify(defaultTexts.current.prompt));
      }

      setTexts({ prompt: promptTxt.current, examples: exampleTexts.current, welcome: msgs.current, app: appTxts.current });
      setTranslating(false);
    }

    if (translating && !translationEffect.current) {
      init();
    }

  }, [translating, lng])

  const changeLng = (newLng) => {
    console.log("changeLng", newLng);
    lng = newLng;
    translationEffect.current = false;
    setTranslating(true);
  }


  return { texts, translating, changeLng };
}


const App = () => {

  //let promptInitText = [initText, questionPairs].join("\n");
  const promptInitText = [initText, questionPairs]

  const [language, setLanguage] = useState(usrlang);
  const prompt = useRef();
  const initData = useRef({});

  //const [page, setPage] = useState(1);

  //sessionStorage.setItem("wisdom-ai", JSON.stringify(payload));
  const currentSession = sessionStorage.getItem("wisdom-ai");
  let initialPage = 1;
  if (currentSession !== null) {
    //console.log("sessionStorage ", currentSession);
    const sessionData = JSON.parse(currentSession);
    initData.current = sessionData.user;
    initialPage = 2;
    promptInitText[0] = promptInitText[0].replace("****", " Wisdom AI");
    promptInitText[0] = promptInitText[0].replace("[name]", sessionData.user.name);
    //promptInitText = promptInitText.replace("[role]", "");

    promptInitText[0] = promptInitText[0].replace("XXXZZZAAA", sessionData.user.location);
    //promptInitText[0] = promptInitText[0].replace("[location]", sessionData.user.location);
    /* 
    initPrompt = initPrompt.replace('[first name]', "");
    initPrompt = initPrompt.replace('[last name]', promptData.user.name);
    initPrompt = initPrompt.replace('[city],', "");
    initPrompt = initPrompt.replace('[country]', promptData.user.location);
    initPrompt = initPrompt.replace(', working as [role] in a [organization name]', "");
  */
  }
  const [page, setPage] = useState(initialPage);


  const { texts, translating, changeLng } = useTranslations(language, promptInitText);
  const [counter, setCounter] = useState(0);

  const [footerHeight, setFooterHeight] = useState(100);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const updateFooterHeight = (newHeight) => {
    //console.log("NEW FOOTER HEIGHT ", newHeight)
    setFooterHeight(newHeight);
    const mainDiv = document.getElementById("main");
    mainDiv.scrollTop = mainDiv.scrollHeight;
  }


  const [chats, setChats] = useState([]);
  const [scrollTop, setScrollTop] = useState(0);
  const [chatId, setChatId] = useState("");

  const answers = useRef({});
  const questions = useRef({});
  const startTS = useRef(new Date());


  const [mic, setMic] = useState(false);
  const speech = useRef("");
  const micUsed = useRef(false);

  const previousEntry = useRef([]);

  const effectCalled = useRef(false);

  useLayoutEffect(() => {
    if (scrollTop > 0) {
      //console.log("LAYOUT ");

      const chatDiv = document.getElementById("chat_container");
      chatDiv.scrollTop = chatDiv.scrollHeight;

    }

    // }
  }, [scrollTop])

  useEffect(() => {
    if (chatId !== "") {
      const msgDiv = document.getElementById(chatId);
      document.getElementById(chatId).querySelector('.dots').style.display = "none";
      if (answers.current[chatId].status === 200) {
        const parsedData = answers.current[chatId].text.trim() // trims any trailing spaces/'\n' 
        previousEntry.current.push(parsedData);
        if (micUsed.current) {
          speakText(parsedData, language)
          //generateTextToSpeech(parsedData);
          micUsed.current = false;
          speech.current = "";
        }

        typeText(msgDiv, parsedData)

        const chatDiv = document.getElementById("chat_container");
        chatDiv.scrollTop = chatDiv.scrollHeight;

      } else {
        const err = answers.current[chatId].statusText;

        msgDiv.innerHTML = err;
      }
    }
  }, [chatId]);

  const promptEntry = async () => {
    // user's chatstripe
    //chatContainer.innerHTML += chatStripe(false, data.get('prompt'))
    console.log(prompt.current.value);
    const mainDiv = document.getElementById("main");
    const chatContainer = document.querySelector('#chat_container');

    // user's chatstripe
    //chatContainer.innerHTML += chatStripeUser(prompt.current.value, 'chat-id');
    const userChat = chatStripeUser(prompt.current.value, 'chat-id', scrollTop, initData.current.name.split(" ")[0]);

    // bot's chatstripe
    const uniqueId = generateUniqueId()
    //chatContainer.innerHTML += chatStripeAI(" ", uniqueId);
    const aiChat = chatStripeAI(" ", uniqueId, scrollTop);

    setChats([...chats, userChat, aiChat]);
    //console.log(chatContainer.scrollHeight, mainDiv.scrollHeight, footerHeight)
    if (chatContainer.scrollHeight > (mainDiv.scrollHeight - footerHeight - 10)) {
      setScrollTop(prev => prev + 1);
    }
    //prompt.current.Height = 40;
    //document.getElementById(prompt.current.id).style.height = "40px !important";

    updateFooterHeight(100);
    // to focus scroll to the bottom 
    // chatContainer.scrollTop = chatContainer.scrollHeight;


    //result: "{\"status\":200,\"statusText\":\"OK\",\"data\":{\"text\":\"\\n\\nThis is a test to see if the sentence is working correctly.\",\"index\":0,\"logprobs\":null,\"finish_reason\":\"stop\"}}"

    if (counter >= process.env.REACT_APP_PRIFINA_WISDOM_MAX_CNT) {
      //console.log("OPEN MODAL....")
      prompt.current.value = "";
      onOpen();
    } else {

      questions.current[uniqueId] = prompt.current.value;

      const payload = {
        init: texts.prompt.join("\n") + "\n" + previousEntry.current.join("\n"),
        prompt: JSON.parse(JSON.stringify(prompt.current.value)),
        user: initData.current,
        answers: JSON.stringify(answers.current).length,
        questions: JSON.stringify(questions.current).length,
        counter: counter,
        start: startTS.current.toISOString(),
        now: new Date().toISOString(),
        lng: language
      }

      sessionStorage.setItem("wisdom-ai", JSON.stringify(payload));

      previousEntry.current = [];
      previousEntry.current.push("Q: " + payload.prompt);
      prompt.current.value = "";
      const response = await API.graphql(
        graphqlOperation(getQuery, { prompt: JSON.stringify(payload) })
      );
      /*
      const response = {
        data: {
          getQuery: {
            result: "{\"status\":200,\"statusText\":\"OK\",\"data\":{\"text\":\"\\n\\nThis is a test to see if the sentence is working correctly.\",\"index\":0,\"logprobs\":null,\"finish_reason\":\"stop\"}}"
          }
        }
      };
*/
      console.log("RES ", response);
      const responseJSON = JSON.parse(response.data.getQuery2.result);

      answers.current[uniqueId] = responseJSON;
      setCounter(prev => prev + 1);
      setChatId(uniqueId);
    }
  }

  useEffect(() => {
    let recognition;
    if (effectCalled.current) {
      if (mic) {
        console.log("RECORDING ",);

        recognition = new window.SpeechRecognition();
        // does this support all browser languages?
        recognition.lang = language;
        recognition.onresult = (event) => {
          const speechToText = event.results[0][0].transcript;
          //console.log("TEXT ", speechToText);
          speech.current = speechToText;
          setMic(false);
        }
        recognition.start();

      } else {

        if (speech.current !== "") {
          //recognition.stop();  recording stops automatically....
          console.log("SEND", speech.current);
          prompt.current.value = speech.current;
          micUsed.current = true;
          promptEntry();
        }
      }

    } else {
      if (!translating) {
        effectCalled.current = true;
        console.log("TEXTS ", texts);
      }
    }

  }, [mic, translating])


  const exampleOnClick = (e) => {
    /*  console.log("EXAMPLE ");
     console.log(e.target.dataset);
     console.log(e.target); */
    const card = parseInt(e.target.dataset.card);
    if (texts.examples[card] !== undefined) {
      prompt.current.value = texts.examples[card];
      document.getElementById("send-prompt").click();
      //promptEntry();
    }
  }

  return <>
    <ChakraProvider>
      {translating && <>
        <div>Loading...</div>
      </>}
      {(page === 1 && !translating) && <>
        <Welcome txts={texts.app} currentLng={language} changeLng={(lng) => {
          //console.log("CHANGE LNG", lng);
          changeLng(lng);
          setLanguage(lng);
        }} init={(data) => {
          initData.current = { name: data.name.value, email: data.email.value, location: data.location.value };
          const chatExamples = examples({ texts: texts.examples, onClick: exampleOnClick });

          const initChat = welcomeChat(initData.current, texts.welcome);
          setChats([initChat, chatExamples]);

          setPage(2);
        }} />
      </>}

      {(page === 2 && !translating) && <>

        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size={{ base: "sm", lg: "xl" }}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader textAlign={"center"} fontWeight={"400"} fontSize={{ base: "24px", lg: "32px" }} lineHeight={{ base: "28px", lg: "37px" }} >{texts.app.title}</ModalHeader>

            <ModalBody pb={6} >
              <Box h={"180px"} textAlign={"center"} >
                <Text mb={"20px"} as={"p"} fontWeight={"400"} fontSize={{ base: "16px", lg: "20px" }} lineHeight={{ base: "18px", lg: "28px" }} >{texts.app.body1}</Text>
                <Text mb={"40px"} as={"p"} fontWeight={"400"} fontSize={{ base: "16px", lg: "20px" }} lineHeight={{ base: "18px", lg: "28px" }} ><span dangerouslySetInnerHTML={{ __html: `${texts.app.body2}` }} /></Text>
                <Button size={["sm", "sm", "md"]} colorScheme='whatsapp' onClick={() => {
                  window.open(process.env.REACT_APP_PRIFINA_WISDOM_BOOK_CALL, '_blank');

                  onClose();
                }}>{texts.app.book}</Button>
              </Box>
            </ModalBody>

          </ModalContent>
        </Modal>

        <Header txts={texts.app} />
        <Box id="main" style={{ marginTop: "80px", overflowY: "auto", height: `calc(100vh - 110px )`, border: "none" }}>
          <MainArea id="scroll">

            <div id="chat_container">
              {chats.map((chat, i) => {
                return <Box key={"chat-" + i}>{chat}</Box>
              })}
            </div>

          </MainArea>
          <Flex id="footer" justifyContent={"center"} style={{ width: "100%", height: `${footerHeight}px`, border: "none" }}>
            <Footer txts={texts.app} ref={prompt} promptEntry={promptEntry} updateFooterHeight={updateFooterHeight} recActive={mic} micClick={() => {
              setMic(prev => !prev);
            }} />
          </Flex>
        </Box>

        <Flex justifyContent={"center"} style={{ position: "fixed", bottom: 0, width: "100%", textAlign: "center" }}>
          <Box style={{ width: "200px" }}>
            <Text mt={"8px"} fontSize={"14px"} lineHeight={"20px"} color={"#718096"}>{counter} / {process.env.REACT_APP_PRIFINA_WISDOM_MAX_CNT} {texts.app.queries}</Text>
          </Box>
        </Flex>
      </>}

    </ChakraProvider>
  </>
}



export default App;
